import { render } from "./CDrawer.vue?vue&type=template&id=6abe4aac"
import script from "./CDrawer.vue?vue&type=script&lang=js"
export * from "./CDrawer.vue?vue&type=script&lang=js"

import "./CDrawer.vue?vue&type=style&index=0&id=6abe4aac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__